import { useState, useEffect } from 'react'
import styles from './KioskScanner.module.css'
import { useNavigate } from "react-router-dom"
// ------ Services ------ //
import * as kioskService from '../../../services/kioskService'
import * as clientEventService from '../../../services/clientEventService'
import * as badgeService from '../../../services/badgeManagementService'
const KioskScanner = ({
    user,
}) => {
    const [kioskSetting, setKioskSetting] = useState();
    const [stylingForm, setStylingForm] = useState();
    const [cSSValues, setCSSValues] = useState();
    const [badgeDimensions, setBadgeDimensions] = useState();
    const [specialCSSRules, setSpecialCSSRules] = useState();
    const [fieldOrdering, setFieldOrdering] = useState({})
    const [backgroundImage, setBackgroundImage] = useState();
    const [headerImage, setHeaderImage] = useState();
    const [sponsorImage, setSponsorImage] = useState();
    const [selectedRegistrant, setSelectedRegistrant] = useState({})
    const [client, setClient] = useState({})
    const [registrantPrintSettings, setRegistrantPrintSettings] = useState();
    const [registrants, setRegistrants] = useState([])
    const [clientEventInfo, setClientEventInfo] = useState({})
     //https://stackoverflow.com/questions/58796727/how-to-implement-barcode-scanner-in-reactjs-application
    const [barcodeRead, setBarcodeRead] = useState("");

    // useLocation & useNavigate --- Client state from previous page
    const navigate = useNavigate()

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (user.ClientId && user.EventId) {
            requestBody =
            {
                "clientId": `${user.ClientId}`,
                "eventId": `${user.EventId}`
            }
        }
        else if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
            }
        }

        return await requestBody;
    }
    const createSingleSearchBody = async (searchQuery) => {
        let requestBody = {}
        if (user.ClientId && user.ClientId) {
            requestBody =
            {
                "clientId": `${user.ClientId}`,
                "eventId": `${user.EventId}`,
                "searchValue": `${searchQuery}`,
            }
        }
        else if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
                "searchValue": `${searchQuery}`,
            }
        }

        return await requestBody;
    }
    // have to fetch header and sponsor
    useEffect(() => {
        if (client && client.clientId) {
            const fetchData = async () => {
                const req = await createRequestBody();
                const setting = await kioskService.getScannerSetting(req)
                if (setting && setting.useBackgroundImage !== undefined && setting.useBackgroundImage === true && setting.backgroundBase64Image) {
                    var tempBackground = 'url(${setting.backgroundBase64Image})';
                    let backgroundImage = {
                        "base64Image": `${setting.backgroundBase64Image}`,
                        "backgroundString": `${tempBackground}`
                    };
                    setBackgroundImage(backgroundImage);
                }
                else {
                    if (setting && (setting.useBackgroundImage === undefined || setting.useBackgroundImage === false) &&
                        setting.headerBase64Image && setting.headerImageWidth) {
                        let tempwidth = setting.headerImageWidth.toString().includes('px') ? setting.headerImageWidth.toString() : setting.headerImageWidth.toString() + 'px';
                        let tempheight = setting.headerImageHeight.toString().includes('px') ? setting.headerImageHeight.toString() : setting.headerImageHeight.toString() + 'px';
                        let headerImage = {
                            "base64Image": `${setting.headerBase64Image}`,
                            "width": `${tempwidth}`,
                            "height": `${tempheight}`,
                        };
                        setHeaderImage(headerImage);
                    }
                    if (setting && (setting.useBackgroundImage === undefined || setting.useBackgroundImage === false) &&
                        setting.sponsorBase64Image && setting.sponsorImageWidth) {
                        let tempwidth = setting.sponsorImageWidth.toString().includes('px') ? setting.sponsorImageWidth.toString() : setting.sponsorImageWidth.toString() + 'px';
                        let tempheight = setting.sponsorImageHeight.toString().includes('px') ? setting.sponsorImageHeight.toString() : setting.sponsorImageHeight.toString() + 'px';
                        let sponsorImage = {
                            "base64Image": `${setting.sponsorBase64Image}`,
                            "width": `${tempwidth}`,
                            "height": `${tempheight}`,
                        };
                        setSponsorImage(sponsorImage);
                    }
                }
               
                //else if (setting && setting.sponsorBase64Image) {
                //    let sponsorImage = {
                //        "base64Image": `${setting.sponsorBase64Image}`
                //    };
                //    setSponsorImage(sponsorImage);
                //}
                setKioskSetting(setting)
            }
            fetchData()
        }
    }, [client])
    useEffect(() => {
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
            setClient(localclientevent)
        }
        else {
            // use user details
            let userDetails = {}
            userDetails =
            {
                "clientId": `${user.ClientId}`,
                "eventId": `${user.EventId}`,
            }
            if (userDetails) {
                setClient(userDetails)
            }
        }
    }, [])

    const barcode = {
        timing: 1000,
        data: "",
    };
    const barcodeReaded = () => {
        if (barcode.data.length > 1) {
            setBarcodeRead(barcode.data);
        } else {
            barcode.data = "";
        }
    };


    let timeout = setTimeout(barcodeReaded, 350);

    useEffect(() => {
        window.addEventListener("keypress", (e) => {
            //console.log(e.key);
            //console.log(e.timeStamp);
            if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 200) {
                barcode.data += e.key;
                barcode.timing = e.timeStamp;
                clearTimeout(timeout);
                timeout = setTimeout(barcodeReaded, 350);
            } else {
                barcode.data = "";
            }
            //console.log(barcode);
        });
    }, []);
    useEffect(() => {
        // store into local object
        // have to pull full registrant
        const fetchData = async () => {
            const item = await kioskService.getAttendeesSearchPaged(await createSingleSearchBody(barcodeRead));
            if (item) {
                item.clientId = user.ClientId !== undefined ? user.ClientId : clientEventInfo.clientId;
                item.eventId = user.EventId !== undefined ? user.EventId : clientEventInfo.eventId;
                item.clientName = user.ClientName !== undefined ? user.ClientName : clientEventInfo.clientName;
            }
            setSelectedRegistrant(item)
            handleSaveAndNavigate()
        };
        if (selectedRegistrant && selectedRegistrant.firstName) {
            fetchData();
        }
    }, [barcodeRead])


    const handleSaveAndNavigate = async () => {
        if (kioskSetting && kioskSetting.skipEditScreen) {
            // retrieve all elements print needs
            // set template settings
            const req = await createRequestBody();
            const templateSettings = await badgeService.getMainTemplate(req)
            //comes through as strings
            var savedStylingForm = templateSettings && templateSettings.stylingForm ? JSON.parse(templateSettings.stylingForm) : null;
            setStylingForm(savedStylingForm)
            var savedCssValues = templateSettings && templateSettings.cssValues ? JSON.parse(templateSettings.cssValues) : null;
            setCSSValues(savedCssValues)
            var savedBadgeDimensions = templateSettings && templateSettings.badgeDimensions ? JSON.parse(templateSettings.badgeDimensions) : null;
            setBadgeDimensions(savedBadgeDimensions)
            var savedSpecialCssRules = templateSettings && templateSettings.specialCSSRules ? JSON.parse(templateSettings.specialCSSRules) : null;
            setSpecialCSSRules(savedSpecialCssRules)
            // set field ordering
            const data = await badgeService.getRegFieldsOrdering(req)
            const items = Array.from(data)
            setFieldOrdering(items)
            let regPrintSettings = {
                cSSValues: savedCssValues,
                specialCSSRules: savedSpecialCssRules,
                fieldOrdering: items
            }
            setRegistrantPrintSettings(regPrintSettings)
            let regTemp = [
                selectedRegistrant
            ]
            setRegistrants(regTemp)
            // navigate to print
            // where should this go/come from? componentRef
            //navigate('/Kiosk/Print', { badgeDimensions: badgeDimensions, registrants: registrants, registrantPrintSettings: registrantPrintSettings, componentRef: componentRef  })
            navigate('/Kiosk/Print', { badgeDimensions: badgeDimensions, registrants: registrants, registrantPrintSettings: registrantPrintSettings })
        }
        else {
            // navigate to the edit screen
            // DS FIX pass all required variables?badgeDimensions: badgeDimensions, stylingForm: stylingForm, CSSValues: cSSValues, specialCSSRules: specialCSSRules, fieldOrdering: fieldOrdering
            navigate('/Kiosk/Edit', { state: selectedRegistrant })
        }
        
    }

    return (
        <div id="kiosk_main">
            <br />
            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            <br />
            {!kioskSetting ?
                <h1 className={styles.setupFailure}>Event Kiosk Setup is not complete!</h1>
                : <></>}
            {headerImage && headerImage.base64Image && headerImage.width ?
                <div className={styles.headerHolder}>
                    <img className={styles.headerImage} src={headerImage.base64Image} style={{ width: headerImage.width, height: headerImage.height }} />
                </div> :
                <></>
            }
            {backgroundImage && backgroundImage.base64Image ?
                <div className={styles.backgroundHolder}>
                    <img className={styles.backgroundImage} style={{ background: backgroundImage.backgroundString }} />
                </div> :
                <></>
            }
            {kioskSetting ?
                <div>
                    <h2>{kioskSetting.pageTitle}</h2>
                    <br /><br />
                    <div>{kioskSetting.scanMessage}</div>
                    <br /><br />
                    <div>{kioskSetting.searchLabel}</div>
                    <br /><br />
                    <button onClick={() => navigate(`/Kiosk/Index`, { state: clientEventInfo })}>Use Search</button>
                 </div>
                : <></>}

        </div>

    );
}

export default KioskScanner;